import React, { useEffect, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import tik from "../../../../../../src/assets/images/Rounds/sign.png";
import cross from "../../../../../../src/assets/images/Rounds/declined.png";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import axios from "axios";
import swal from "sweetalert";
import { Markup } from "interweave";
import { useHistory } from "react-router-dom";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";

const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
  // <img src={LeftArrow} alt="prevArrow" {...props} />
  <FaArrowLeft {...props} />
);
const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
  <FaArrowRight {...props} />
);

// page-no-448
function LearningLiveSession(props) {

  const { videoCdnUrl } = useContext(serverInfo);

  const [events, setEvents] = useState([]);
  const [showSelectedTab, setShowSelectedTab] = useState(true);
  const [selectedVideo, setSelectedVideo] = useState({});
  const [allSelectedVideo, setAllSelectedVideo] = useState([]);
  const [allRejectedVideo, setAllRejectedVideo] = useState([]);
  const [comment, setComment] = useState("");
  const [mark, setMark] = useState("");
  const [instruction, setInstruction] = useState("");
  const [sendToStar, setSendToStar] = useState(true);

  //star
  const [starEvents, setStarEvents] = useState([]);
  const [starApprovedEvents, setStarApprovedEvents] = useState([]);

  const fetchData = (id) => {
    axios.get(`/api/admin/learning_session/assignment/${id}`).then((res) => {
      if (res.data.status === 200) {
        setInstruction(res.data.instruction);

        //Manager
        setEvents(res.data.event);
        setAllSelectedVideo(res.data.approved_event);
        setAllRejectedVideo(res.data.rejected_event);

        //Star
        setStarEvents(res.data.star_event);
        setStarApprovedEvents(res.data.star_approved_event);


      }
    });
  };

  useEffect(() => {
    const id = props.event?.id;
    fetchData(id);
  }, [props]);

  const handleSelectedVideo = (event) => {
    setSelectedVideo(event);
  };

  //Prepare for Star
  const approvalHandler = () => {
    const fData = new FormData();
    fData.append("comment", comment);
    const type = "approve";

    axios
      .post(
        `/api/admin/learning_session/assignment/approval/${type}/${selectedVideo.id}`,
        fData
      )
      .then((res) => {
        if (res.data.status === 200) {
          setMark(0);
          setComment("");

          fetchData(props.event?.id);
        }
      });
  };

  const approvalWithMarkHandler = () => {
    if (mark === "" || mark < 1) {
      swal("Warning", "Minimum Mark 01 Required", "warning");
    } else {
      const fData = new FormData();
      fData.append("comment", comment);
      fData.append("mark", mark);
      const type = "approve";

      axios
        .post(
          `/api/admin/learning_session/assignment/approval/withMark/${type}/${selectedVideo.id}`,
          fData
        )
        .then((res) => {
          if (res.data.status === 200) {
            setMark(0);
            setComment("");

            fetchData(props.event?.id);
          }
        });
    }
  };

  const rejectHandler = () => {
    if (comment === "") {
      swal("Warning", "Comment Required", "warning");
    } else {
      const fData = new FormData();
      fData.append("comment", comment);
      fData.append("mark", 0);
      const type = "reject";

      axios
        .post(
          `/api/admin/learning_session/assignment/approval/${type}/${selectedVideo.id}`,
          fData
        )
        .then((res) => {
          if (res.data.status === 200) {
            setMark(0);
            setComment("");
            //insert
            setAllRejectedVideo((oldArray) => [...oldArray, selectedVideo]);

            //spice
            const currentIndex = events.indexOf(selectedVideo);
            const newChecked = [...events];
            newChecked.splice(currentIndex, 1);
            setEvents(newChecked);

            //spice2
            const currentIndex2 = starEvents.indexOf(selectedVideo);
            const newChecked2 = [...starEvents];
            newChecked2.splice(currentIndex2, 1);
            setStarEvents(newChecked2);
          }
        });
    }
  };

  const sendToMangerHandler = () => {
    axios
      .get(
        `/api/admin/learning_session/assignment/send_to_manager/${props.event?.id}`
      )
      .then((res) => {
        if (res.data.status === 200) {
        }
      });
  };

  const sendToStarHandler = () => {
    axios
      .get(
        `/api/admin/learning_session/assignment/send_to_star/${props.event?.id}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          setSendToStar(false);
        }
      });
  };

  const tabChanger = (value) => {
    if (value === 1) setShowSelectedTab(true);
    else setShowSelectedTab(false);
  };

  const history = useHistory();

  const markSheetController = () => {
    history.push(
      `/superstar-admin/learning-session/evaluation/markSheet/${props.event?.slug}`
    );
  };

  return (
    <>
      <div className="AS">
        <div className="container-fluid">
          <div className="row my-4">
            <div className="col-md-md-12">
              <div className="card card-bg shadow border-warning">
                <div className="card-body">
                  <Tab.Container
                    id="left-tabs-example"
                    defaultActiveKey="first"
                  >
                    <Nav variant="pills" className="d-flex">
                      <div className="col-md-md-6 small-live-session mb-3">
                        <Nav.Item>
                          <Nav.Link
                            eventKey="first"
                            className="TabCardGold d-flex  text-decoration-none text-center me-2 fw-bold pt-3 "
                          >
                            <h4 className="font-style ">Prepare For My Self</h4>
                          </Nav.Link>
                        </Nav.Item>
                      </div>
                      <div className="col-md-md-6 small-live-session">
                        <Nav.Item>
                          <Nav.Link
                            eventKey="second"
                            className="TabCardGold py-2 fw-bold pt-3 text-decoration-none text-center "
                          >
                            <h4 className="font-style">
                              Prepare For The Superstar
                            </h4>
                          </Nav.Link>
                        </Nav.Item>
                      </div>
                    </Nav>

                    <Tab.Content>
                      <Tab.Pane eventKey="first">
                        <div className="row mt-3 me-2">
                          <h5 className="pt-3 text-light">
                            Upload Video Instruction
                          </h5>
                          <div className="bg-dark pt-3 mx-2 mt-2">
                            <p className="text-light">
                              <Markup content={instruction}></Markup>
                            </p>
                          </div>
                          <div className="bg-dark py-2 mx-2 mt-4">
                            <h4 className="text-light">All User Videos</h4>
                          </div>

                          <div className="row my-3 ">
                            {events &&
                              events.map((event, index) => (
                                <div
                                  className="col-md-4 mb-3 vide-w"
                                  onClick={() => handleSelectedVideo(event)}
                                >
                                  <div className="mx-1">
                                    <video
                                      className="VIDEO-x"
                                      controls
                                      src={
                                        event.video != null
                                          ? videoCdnUrl + event.video
                                          : "https://youtu.be/dgfTiONcnTc"
                                      }
                                      style={
                                        selectedVideo.id === event.id
                                          ? {
                                            border: "1px solid gold",
                                            borderRadius: "20px",
                                            cursor: "pointer",
                                          }
                                          : {
                                            cursor: "pointer",
                                          }
                                      }
                                    ></video>
                                  </div>
                                </div>
                              ))}
                          </div>

                          <div className="row justify-content-between mb-3">
                            <div className="col-sm-8">
                              <h5 className="text-light">Comment:</h5>
                              <div className="d-flex">
                                <input
                                  type="text"
                                  className="input-fieldx form-control p-2 rounded "
                                  placeholder="Write Comment Here...."
                                  onChange={(e) => setComment(e.target.value)}
                                />
                                <button className="mx-2 ">
                                  {" "}
                                  <img
                                    src={cross}
                                    alt=""
                                    height={"40px"}
                                    onClick={rejectHandler}
                                  />
                                </button>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <h5 className="text-light">Mark:</h5>

                              <div className="d-flex">
                                <input
                                  type="number"
                                  className="input-fieldx form-control p-2 fw-bold rounded"
                                  value={mark}
                                  onChange={(e) => setMark(e.target.value)}
                                />
                                <button className="mx-2">
                                  <img
                                    src={tik}
                                    alt=""
                                    height={"40px"}
                                    onClick={approvalWithMarkHandler}
                                  />
                                </button>
                              </div>
                            </div>
                          </div>

                          <hr
                            style={{
                              color: "white",
                              backgroundColor: "white",
                              height: 2,
                              borderColor: "white",
                            }}
                          />

                          {showSelectedTab ? (
                            <>
                              <h5 className="text-light">
                                Marked Videos (
                                {allSelectedVideo && allSelectedVideo.length})
                              </h5>

                              <div className="row my-3 ">
                                {allSelectedVideo &&
                                  allSelectedVideo.map((event, index) => (
                                    <>
                                      <div
                                        className="col-md-4 mb-3 vide-w"
                                        onClick={() =>
                                          handleSelectedVideo(event)
                                        }
                                      >
                                        <div className="mx-1">
                                          <video
                                            className="VIDEO-x"
                                            controls
                                            src={
                                              event.video != null
                                                ? videoCdnUrl + event.video
                                                : null
                                            }
                                          ></video>
                                          <p className="text-light">
                                            Mark: <strong>{event.mark}</strong>
                                          </p>
                                        </div>
                                      </div>
                                    </>
                                  ))}
                              </div>
                            </>
                          ) : (
                            <div className="my-3">
                              <h5 className="text-danger">
                                Rejected Videos (
                                {allRejectedVideo && allRejectedVideo.length})
                              </h5>
                              <div className="row my-3 ">
                                {allRejectedVideo &&
                                  allRejectedVideo.map((event, index) => (
                                    <>
                                      <div
                                        className="col-md-4 mb-3 vide-w"
                                        onClick={() =>
                                          handleSelectedVideo(event)
                                        }
                                      >
                                        <div className="mx-1">
                                          <video
                                            className="VIDEO-x"
                                            controls
                                            src={
                                              event.video != null
                                                ? videoCdnUrl + event.video
                                                : null
                                            }
                                          ></video>
                                        </div>
                                      </div>
                                    </>
                                  ))}
                              </div>
                            </div>
                          )}

                          <buttonGroup
                            aria-label="Basic example"
                            className="mt-4"
                          >
                            <button
                              variant="secondary"
                              className="mx-1 rounded-3 text-light p-2 bg-success"
                              onClick={() => tabChanger(1)}
                            >
                              Approved
                            </button>
                            <button
                              variant="secondary"
                              className="mx-1 rounded-3 text-light p-2 bg-danger"
                              onClick={() => tabChanger(2)}
                            >
                              Rejected
                            </button>
                          </buttonGroup>

                          {/* {events && events.length === 0 && starApprovedEvents.length == 0 ? (
                          <button className="btn mt-4 fw-bold mx-2 BTBbtn" onClick={sendToMangerHandler}>
                            <h5 className="fw-bold">Send To The Manager</h5>
                          </button>
                          ) : ''} */}
                        </div>
                      </Tab.Pane>

                      <Tab.Pane eventKey="second">
                        <div className="row mt-3 me-2">
                          <h5 className="pt-3 text-light">
                            Upload Video Instruction
                          </h5>
                          <div className="bg-dark pt-3 mx-2 mt-2">
                            <p className="text-light">
                              <Markup content={instruction}></Markup>
                            </p>
                          </div>
                          <div className="bg-dark py-2 mx-2 mt-4">
                            <h4 className="text-light">All User Videos</h4>
                          </div>

                          <div className="row my-3">
                            {events &&
                              events.map((event, index) => (
                                <div
                                  className="col-md-4 mb-3 vide-w"
                                  onClick={() => handleSelectedVideo(event)}
                                >
                                  <div className="mx-1">
                                    <video
                                      className="VIDEO-x"
                                      controls
                                      src={
                                        event.video != null
                                          ? videoCdnUrl + event.video
                                          : "https://youtu.be/dgfTiONcnTc"
                                      }
                                      style={
                                        selectedVideo.id === event.id
                                          ? {
                                            border: "1px solid gold",
                                            borderRadius: "20px",
                                            cursor: "pointer",
                                          }
                                          : {
                                            cursor: "pointer",
                                          }
                                      }
                                    ></video>
                                  </div>
                                </div>
                              ))}
                          </div>

                          <div className="row justify-content-between mb-3">
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Write Comment Here...."
                                onChange={(e) => setComment(e.target.value)}
                              />
                            </div>
                            <div className="col-md-4 ">
                              <div className="d-flex justify-content-around user-coment-btn">
                                <button
                                  className="mx-1  "
                                  onClick={approvalHandler}
                                >
                                  <img
                                    src={tik}
                                    alt=""
                                    height={"40px"}
                                    onClick={approvalHandler}
                                  />
                                </button>

                                <button onClick={rejectHandler}>
                                  <img
                                    src={cross}
                                    alt=""
                                    height={"40px"}
                                    type="button"
                                    onClick={rejectHandler}
                                  />
                                </button>
                              </div>
                            </div>
                          </div>

                          <hr
                            style={{
                              color: "white",
                              backgroundColor: "white",
                              height: 2,
                              borderColor: "white",
                            }}
                          />

                          {showSelectedTab ? (
                            <>
                              <h5 className="text-light">
                                Approved Videos (
                                {starApprovedEvents &&
                                  starApprovedEvents.length}
                                )
                              </h5>
                              <div className="row my-3 ">
                                {starApprovedEvents &&
                                  starApprovedEvents.map((event, index) => (
                                    <div className="col-md-4 mb-3">
                                      <div className="card border-0 card-bg">
                                        <div
                                          className=" d-flex justify-content-center"
                                          onClick={() =>
                                            handleSelectedVideo(event)
                                          }
                                          style={{
                                            height: "200px",
                                          }}
                                        >
                                          <video
                                            controls
                                            className="video me-3"
                                            src={videoCdnUrl + event.video}
                                            style={{
                                              height: "200px",
                                              width: "290px",
                                            }}
                                          ></video>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </>
                          ) : (
                            <>
                              <h5 className="text-danger">
                                Rejected Videos (
                                {allRejectedVideo && allRejectedVideo.length})
                              </h5>
                              <div className="row my-3 ">
                                {allRejectedVideo &&
                                  allRejectedVideo.map((event, index) => (
                                    <>
                                      <div className="col-md-4 mb-3">
                                        <div className="card border-0 card-bg">
                                          <div
                                            className=" d-flex justify-content-center"
                                            onClick={() =>
                                              handleSelectedVideo(event)
                                            }
                                            style={{
                                              height: "200px",
                                            }}
                                          >
                                            <video
                                              controls
                                              className="video me-3"
                                              src={videoCdnUrl + event.video}
                                              style={{
                                                height: "200px",
                                                width: "290px",
                                              }}
                                            ></video>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ))}
                              </div>
                            </>
                          )}

                          <buttonGroup
                            aria-label="Basic example"
                            className="mt-4"
                          >
                            <button
                              variant="secondary"
                              className="mx-1 p-2 bg-success rounded-3 text-light"
                              onClick={() => tabChanger(1)}
                            >
                              Approved
                            </button>
                            <button
                              variant="secondary"
                              className="mx-1 p-2 bg-danger rounded-3 text-light"
                              onClick={() => tabChanger(2)}
                            >
                              Rejected
                            </button>
                          </buttonGroup>

                          {starEvents &&
                            starEvents.length === 0 &&
                            sendToStar ? (
                            <div className="text-center">
                              <button
                                className="btn BTBbtn mt-4 fw-bold mx-2 send-btn"
                                onClick={sendToStarHandler}
                              >
                                <h5 className="fw-bold">Send To Star</h5>
                              </button>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              </div>

              <button
                className="btn mt-4 fw-bold mx-2 BTBbtn"
                onClick={markSheetController}
              >
                <h5 className="fw-bold">Show Marksheet</h5>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LearningLiveSession;
